import React from 'react';
import ClauseProfileRow from './ClauseProfileRow';
import Selectors from '../hooks/selectors';

const ClausesProfileRows = ({
  category,
  code,
  queryUUID,
  dictionaryCode,
}) => {
  const { entities } = Selectors.useClausesProfileRows({
    category, code, queryUUID, dictionaryCode,
  });
  return (
    entities.map((item, index) => (
      <ClauseProfileRow
        key={`clauses_profile_table_row_${item.field.label}`}
        total={item.total_value}
        count={item.count}
        label={item.field.label}
        first={index === 0}
      />
    ))
  );
};

export default ClausesProfileRows;
